export default {"src":"/_next/static/media/physio.0b07cc3b.svg","height":900,"width":702};